import { BaseAPI } from "./BaseAPI";

import type { CommentListItem } from "./AdminUserAPI.types";
import type { APIConf } from "./BaseAPI";
import type { CommentListParams, CommentUuidsParams } from "./CommentAPI.types";

class CommentAPIClass extends BaseAPI {
  constructor(conf: APIConf) {
    super(conf);
    this.service = "user";
    this.version = "v3";
  }

  get commentsRoute(): string {
    return `${this.routeBase}/admin/comments`;
  }

  /** Tous les commentaires du projet : le serveur ne pagine, ne trie ni ne cherche. */
  async getCommentList({
    projectSlug,
  }: CommentListParams): Promise<CommentListItem[]> {
    const { data } = await this.axios.post<{ data?: CommentListItem[] }>(
      this.commentsRoute,
      undefined,
      { headers: { "xx-ok-project": projectSlug } },
    );

    if (!Array.isArray(data?.data)) {
      throw new Error("Unexpected comments response");
    }

    return data.data;
  }

  async validateComments({
    projectSlug,
    uuids,
  }: CommentUuidsParams): Promise<void> {
    await this.axios.post(
      `${this.commentsRoute}/validate`,
      { uuids },
      { headers: { "xx-ok-project": projectSlug } },
    );
  }

  async deleteComments({
    projectSlug,
    uuids,
  }: CommentUuidsParams): Promise<void> {
    await this.axios.delete(`${this.commentsRoute}/delete`, {
      data: { uuids },
      headers: { "xx-ok-project": projectSlug },
    });
  }
}

const CommentAPI = new CommentAPIClass({
  token: localStorage.token,
});

export default CommentAPI;
